import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thumbnail'
})
export class ThumbnailPipe implements PipeTransform {
  transform(url: string): string {
    if (!url) return url; // Validar que la URL no sea nula

    // Separar la URL en partes
    const parts = url.split('/');
    const filename = parts.pop();

    if (filename) {
      const newFilename = `thumbnail_${filename}`; // Agregar "thumbnail_" al inicio
      return [...parts, newFilename].join('/'); // Reconstruir la URL
    }

    return url;
  }
}
